export default {
    apiKey: "AIzaSyCtQQc5fNQbc3FYSLgjcSJ4zVFkHW1sp5U",
    authDomain: "hello-markets.firebaseapp.com",
    databaseURL: "https://hello-markets.firebaseio.com",
    projectId: "hello-markets",
    storageBucket: "hello-markets.appspot.com",
    messagingSenderId: "658203056862",
    appId: "1:658203056862:web:27eab38f4d415c56d9804f",
    measurementId: "G-J71MTYGJ0C"
};
